const elements = document.querySelectorAll('[data-slide]');

Array.prototype.forEach.call(elements, function(element) {
  element.addEventListener("touchstart", startTouch, false);
  element.addEventListener("touchmove", moveTouch, false);
});

// Swipe Up / Down / Left / Right
var initialX = null;
var initialY = null;
 
function startTouch(e) {
  initialX = e.touches[0].clientX;
  initialY = e.touches[0].clientY;
};
 
function moveTouch(e) {
  if (spotlightSlider.isPaused()) {
    return false;
  }

  const slideElement = e.target.closest('section');
  const slideNr = slideElement.getAttribute('data-slide');

  if (initialX === null) {
    return;
  }
 
  if (initialY === null) {
    return;
  }
 
  var currentX = e.touches[0].clientX;
  var currentY = e.touches[0].clientY;
 
  var diffX = initialX - currentX;
  var diffY = initialY - currentY;
 
  if (Math.abs(diffX) > Math.abs(diffY)) {
    // sliding horizontally
    if (diffX > 0) {
      // swiped left
    } else {
      // swiped right
    }  
  } else {
    // sliding vertically
    if (diffY > 0) {
      // swiped up
      if (spotlightSlider.isLastSlide()) {
        spotlightSlider.scroll();
      } else {
        spotlightSlider.goToNextSlide();
      }
    } else {
      // swiped down
      if (slideNr == 1) {
        return false;
      }
      if (spotlightSlider.isTop()) {
        spotlightSlider.addBodyClass();
      }  
      spotlightSlider.goToPreviousSlide();
    }  
  }
 
  initialX = null;
  initialY = null;
  
  return false;

  e.preventDefault();
};